<div class="loading-overlay" *ngIf="(loadingState$ | async)?.isLoading">
	<div class="loading-content">
		<mat-spinner diameter="40"></mat-spinner>
		<p class="loading-text">{{ (loadingState$ | async)?.message || "Loading..." }}</p>
	</div>
</div>
